import React from 'react';
import {
  Box,
  FormControl,
  Flex,
  Text,
  Spinner,
  useColorModeValue,
} from '@chakra-ui/react';
import Select from 'react-select';

const FileTypeSelector = ({
  fileTypes,
  fileType,
  scheme,
  loadingFileTypes,
  handleFileTypeChange,
  mapOptions,
}) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: 5,
      minHeight: '32px',
      height: '32px',
      borderColor: state.isFocused ? '#2c7a7a' : borderColor,
      boxShadow: state.isFocused ? '0 0 0 1px #2c7a7a' : 'none',
      '&:hover': {
        borderColor: '#2c7a7a',
      },
      fontSize: '13px',
      backgroundColor: 'white',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 8px',
      height: '32px',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '32px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '4px',
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '4px',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: '2px',
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      borderRadius: 0,
      maxHeight: '250px',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#2c7a7a' : state.isFocused ? '#e6fffa' : 'white',
      color: state.isSelected ? 'white' : '#1a202c',
      fontSize: '14px',
      zIndex: 9999,
      padding: '8px 12px',
      '&:active': {
        backgroundColor: '#2c7a7a',
      },
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: '13px',
      color: '#a0aec0',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '13px',
      color: '#1a202c',
    }),
  };

  return (
    <Box>
      <FormControl>
        {loadingFileTypes ? (
          <Flex
            align="center"
            justify="center"
            p={2}
            border="1px solid"
            borderColor={borderColor}
            bg="gray.50"
            minH="32px"
          >
            <Spinner size="xs" mr={2} color="teal.500" />
            <Text fontSize="xs" color="gray.500">Loading...</Text>
          </Flex>
        ) : (
          <Select
            options={mapOptions(fileTypes)}
            value={mapOptions(fileTypes).find((opt) => opt.value === fileType) || null}
            onChange={handleFileTypeChange}
            placeholder={!scheme ? 'Select scheme first' : 'Select file type'}
            isDisabled={!scheme || fileTypes.length === 0}
            styles={customSelectStyles}
            isClearable
            isSearchable
            menuPortalTarget={document.body}
            menuPosition="fixed"
            noOptionsMessage={() => !scheme ? 'Select a scheme first' : 'No file types found'}
          />
        )}
      </FormControl>
    </Box>
  );
};

export default FileTypeSelector;